import React from "react";
import { connect } from "react-redux";
import { groupOperationalHours } from "signoxe/actions/remote";

import "./styles.scss";

class OperationalHours extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startHour: "",
      startMin: "",
      endHour: "",
      endMin: "",
      nonOperationalActivity: "",
      buttonVisible: false,
      loading: false,
    };
  }

  componentDidMount() {
    this.getDeviceGroupData();
  }

  getDeviceGroupData() {
    if(this.props.device){
      return this.setState({
        startHour: this.props.device.operation_start_time.split(":")[0],
        startMin: this.props.device.operation_start_time.split(":")[1],
        endHour: this.props.device.operation_end_time.split(":")[0],
        endMin: this.props.device.operation_end_time.split(":")[1],
        nonOperationalActivity: this.props.device.non_operation_activity,
        buttonVisible: false,
      });
      
      document.getElementById("non-operational-activity").selectedIndex =
      this.props.device.non_operation_activity;
    }else{
      return this.setState({
        startHour: 0,
        startMin: 0,
        endHour: 0,
        endMin: 0,
        nonOperationalActivity: 0,
        buttonVisible: false,
      });
      
      document.getElementById("non-operational-activity").selectedIndex = 0;
    }
  }

  cancelOperationalHours = () => {
    this.getDeviceGroupData();
  };

  submitOperationalHours = () => {
    const { startHour, startMin, endHour, endMin, nonOperationalActivity } =
      this.state;

    if (startHour <= 9) {
      startHour = "0" + startHour;
    }

    if (startMin <= 9) {
      startMin = "0" + startMin;
    }

    if (endHour <= 9) {
      endHour = "0" + endHour;
    }

    if (endMin <= 9) {
      endMin = "0" + endMin;
    }

    let start_time = `${this.state.startHour}:${this.state.startMin}:00`;
    let end_time = `${this.state.endHour}:${this.state.endMin}:00`;

    let operationalData = {
      start_time,
      end_time,
      activity: nonOperationalActivity,
      group_id: this.props.groupId,
    };
    this.setState({ loading: true });
    this.props.groupOperationalHours(operationalData, (result) => {
      if (result == 400) {
        this.cancelOperationalHours();
      }
      this.setState({ loading: false });
    });
    this.setState({ buttonVisible: false });
  };
  render() {

    return (
      <div className="operational-hours-view">
        <div className="operational-time">
          <h3>Operational Hours:</h3>
          <div className="time-inputs">
            <input
              type="number"
              className="operation-time-input"
              disabled={this.state.loading}
              value={this.state.startHour}
              onChange={(e) => {
                let hour = e.target.value;
                if (hour >= 0 && hour < 24) {
                  this.setState({
                    startHour: hour,
                    buttonVisible: true,
                  });
                }
              }}
            />
            <span>:</span>
            <input
              type="number"
              className="operation-time-input"
              disabled={this.state.loading}
              value={this.state.startMin}
              onChange={(e) => {
                let min = e.target.value;
                if (min >= 0 && min < 60) {
                  this.setState({
                    startMin: min,
                    buttonVisible: true,
                  });
                }
              }}
            />
            <span>-</span>
            <input
              type="number"
              className="operation-time-input"
              disabled={this.state.loading}
              value={this.state.endHour}
              onChange={(e) => {
                let hour = e.target.value;
                if (hour >= 0 && hour < 24) {
                  this.setState({
                    endHour: hour,
                    buttonVisible: true,
                  });
                }
              }}
            />
            <span>:</span>
            <input
              type="number"
              className="operation-time-input"
              disabled={this.state.loading}
              value={this.state.endMin}
              onChange={(e) => {
                let min = e.target.value;
                if (min >= 0 && min < 60) {
                  this.setState({
                    endMin: min,
                    buttonVisible: true,
                  });
                }
              }}
            />
          </div>
        </div>
        <p>Here you can set up operational hours for devices.</p>
        <div className="operational-time">
          <h3>Devices to</h3>{" "}
          <select
            name="non-operational-activity"
            id="non-operational-activity"
            disabled={this.state.loading}
            value={this.state.nonOperationalActivity}
            onChange={(e) => {
              let activity = e.target.value;
              this.setState({
                nonOperationalActivity: activity,
                buttonVisible: true,
              });
            }}
          >
            <option value="1">Remain Active</option>
            {/* <option value="2">Sleep</option>
            <option value="3">Show Black Screen</option> */}
            <option value="4">Turn Off</option>
          </select>{" "}
          <h3>during non-operational hours.</h3>
        </div>

        {this.state.loading && (
          <div className="actions">Wait till the request is processing...</div>
        )}

        {this.state.buttonVisible && !this.state.loading && (
          <div className="actions">
            <button
              className="button outline-primary"
              type="button"
              onClick={this.cancelOperationalHours}
            >
              Cancel
            </button>
            <button
              className="button"
              type="button"
              onClick={this.submitOperationalHours}
            >
              Save
            </button>
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    groupOperationalHours: (data, callback) =>
      dispatch(groupOperationalHours(data, callback)),
  };
};

export default connect(null, mapDispatchToProps)(OperationalHours);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/OperationalHours/index.js